import * as React from "react";
const Add_location = ({theme}) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
     
  >
    <path
      d="M12.0001 22C12.0001 22 20.0291 16.44 20.0001 10C20.0001 5.589 16.4111 2 12.0001 2C7.58908 2 4.00008 5.589 4.00008 9.995C3.97108 16.44 11.6961 21.784 12.0001 22ZM8.00008 9H11.0001V6H13.0001V9H16.0001V11H13.0001V14H11.0001V11H8.00008V9Z"
      fill={theme === "dark" ? "#232A47":'#F1F5F9'}
    />
  </svg>
);
export default Add_location;
